// Đầu thẻ kiểu tạp chí cho các màn số liệu của trang Lương (Chi tiết lương, Tổng quan, bảng
// phòng): nhãn nhỏ viết hoa, một con số tiền LỚN chữ có chân, câu nghiêng, và lưới chỉ số kẻ
// mảnh bên phải. Chỉ VẼ số được đưa vào — không tự tính gì.
import type { ReactNode } from "react";
// Bảng kê chi tiết còn mở ở nơi khác ngoài PayrollView (màn xem thử) — tự nạp áo.
import "./luong-tap-chi.css";
import { vnd } from "../constants";

export type ChiSo = {
  nhan: ReactNode;
  giaTri: ReactNode;
  phu?: ReactNode;
  testId?: string | undefined;
};

type Props = {
  nhan: ReactNode;
  /** Số tiền (đồng). */
  so: number;
  loiMoi?: ReactNode;
  chiSo?: ChiSo[] | undefined;
  /** Phần thêm dưới câu nghiêng (nhãn trạng thái, ghi chú). */
  phuLuc?: ReactNode;
};

export function DauSo({ nhan, so, loiMoi, chiSo, phuLuc }: Props) {
  const co = (chiSo?.length ?? 0) > 0;
  return (
    <div className="lt-dau-so" data-co-chi-so={co ? "" : undefined}>
      <div className="min-w-0">
        <span className="lt-nhan">{nhan}</span>
        <b className="lt-so-lon" data-testid="dau-so-lon">
          {vnd(so).replace(/đ$/, "")}
          <small>đ</small>
        </b>
        {loiMoi && <p className="lt-loi-moi mt-2 text-[19px]">{loiMoi}</p>}
        {phuLuc}
      </div>
      {co && (
        <div className="lt-chi-so">
          {chiSo!.map((c, i) => (
            <div key={i} data-testid={c.testId}>
              <span className="lt-nhan">{c.nhan}</span>
              <b>{c.giaTri}</b>
              {c.phu && <p>{c.phu}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
